import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';

class StickyCartSummary extends HTMLElement {
  #unsubscribers = [];
  #targetHidden = false;
  #footerVisible = false;
  #targetObserver = null;

  connectedCallback() {
    this.#observeCheckoutButton();
    this.#observeFooter();

    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => {
          this.#updateTotal(sections);
          this.#observeCheckoutButton();
        })
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
    this.#targetObserver?.disconnect();
  }

  #observeCheckoutButton() {
    this.#targetObserver?.disconnect();

    const checkoutButton = document.querySelector('cart-summary [name="checkout"]');
    if (!checkoutButton) return;

    this.#targetObserver = new IntersectionObserver(([{ isIntersecting }]) => {
      this.#targetHidden = !isIntersecting;
      this.#updateVisibility();
    });

    this.#targetObserver.observe(checkoutButton);
  }

  #observeFooter() {
    const footerBottom = document.querySelector('footer.shopify-section--footer .footer--bottom');
    if (!footerBottom) return;

    new IntersectionObserver(([{ isIntersecting }]) => {
      this.#footerVisible = isIntersecting;
      this.#updateVisibility();
    }).observe(footerBottom);
  }

  #updateVisibility() {
    const show = this.#targetHidden && !this.#footerVisible;
    this.classList.toggle('translate-y-0', show);
    this.classList.toggle('translate-y-full', !show);
    this.classList.toggle('opacity-0', !show);
  }

  #updateTotal(sections) {
    const html = parseHTML(sections['fetch-cart-summary']);
    const total = html.querySelector('[data-total]');
    const stickyTotal = this.querySelector('[data-sticky-total]');

    if (total && stickyTotal) {
      stickyTotal.textContent = total.textContent;
    }
  }
}

customElements.define('sticky-cart-summary', StickyCartSummary);
